export { FileIcon } from './file-icon';
export type { FileIconProps } from './file-icon';
export const FILE_ICON = 'FILE_ICON';
